module.exports = __webpack_public_path__ + "img/geofisica_3-4_1536.6a0b8b5d.webp";